import React from 'react';
import { VirtualizedTreeListProvider } from 'shared/components/ui/virtualized-tree-list';

import { TaskFilterList } from './task-filter-list';
import { TaskFilterListProps } from './types';

export const ProvidedTaskFilterList: React.FC<TaskFilterListProps> = (
  props,
) => (
  <VirtualizedTreeListProvider>
    <TaskFilterList {...props} />
  </VirtualizedTreeListProvider>
);
